import { Subtitle } from "chq";
import secondsToTimeString from "./secondsToTimeString";

const updateActiveSubtitleText = (
  active: boolean,
  onUpdateSubtitles: (newData: Record<string, any>) => void,
  subtitles: Subtitle[],
  deleted?: boolean
) => {
  const activeSubtitleIndex = subtitles.findIndex(subtitle => subtitle.active);
  const activeSubtitle = subtitles[activeSubtitleIndex];
  if (activeSubtitle?.sections) {
    const newText = activeSubtitle.sections.filter(section => !section.hidden).map(
      (section, index) => [
        index, `${secondsToTimeString(section.startTime)} --> ${secondsToTimeString(section.endTime)}`, section.text
      ].join("\n")
    ).join("\n\n");
    onUpdateSubtitles({
      subtitles: subtitles.map(subtitle => (
        subtitle.id === activeSubtitle.id ? {
          ...activeSubtitle,
          text: `WEBVTT\n\n${newText}`,
          active,
          deleted
        } : subtitle
      ))
    });
  }
};

export default updateActiveSubtitleText;
